import { Text, Pressable } from "react-native";
import React from "react";
import Animated from "react-native-reanimated";
import i18n from "../locales/i18n";
import { Link } from "expo-router";

interface DebtItem {
  id_debt?: number;
  createdAt?: string;
  amount?: number;
  paidamount?: number;
  fullname?: string;
}

interface DateItemsProps {
  element: DebtItem;
  index: number;
}

const DateItems: React.FC<DateItemsProps> = ({ element, index }) => {
  const locale = i18n.locale;
  // Safety check - return null if element is not valid
  if (!element || typeof element !== "object") {
    return null;
  }

  // Calculate remaining debt
  const totalAmount = element?.amount || 0;
  const paidAmount = element?.paidamount || 0;
  const remainingAmount = totalAmount - paidAmount;
  const paymentPercentage =
    totalAmount > 0 ? (paidAmount / totalAmount) * 100 : 0;

  // Determine status color based on payment
  const getStatusColor = () => {
    if (remainingAmount <= 0) return "#22C55E"; // Green - Fully paid
    if (paidAmount > 0) return "#F59E0B"; // Orange - Partially paid
    return "#EF4444"; // Red - Not paid
  };

  return (
    <Link
      href={`/dettes/${element?.id_debt || ""}`}
      className="w-full "
      asChild={true}
    >
      <Pressable className="w-full ">
        <Animated.View
          className={`${locale == "fr" ? "flex-row-reverse" : "flex-row "}
        
        w-full  flex    py-4 justify-between rounded-lg px-2 mb-2`}
          style={{
            backgroundColor: index % 2 == 0 ? "#A6CFFF" : "#FBFBFB",
            borderLeftWidth: 4,
            borderLeftColor: getStatusColor(),
          }}
        >
          <Text className="font-bold flex-1 text-center text-sm text-gray-800">
            {element?.createdAt?.split("T")[0] || "N/A"}
          </Text>

          {/* Original Amount */}
          <Text className="font-bold text-center flex-1 text-sm text-gray-800">
            {totalAmount} {i18n.t("currency")}
          </Text>

          {/* Paid Amount */}
          <Text
            className="font-bold flex-1 text-center text-sm"
            style={{ color: getStatusColor() }}
          >
            {paidAmount} {i18n.t("currency")}
          </Text>

          {/* Remaining Amount */}
          <Text
            className="font-bold flex-1 text-center text-sm"
            style={{ color: remainingAmount > 0 ? "#EF4444" : "#22C55E" }}
          >
            {remainingAmount} {i18n.t("currency")}
          </Text>

          <Text className="font-bold flex-1 text-center text-sm text-gray-800">
            {element?.fullname || "N/A"}
          </Text>
        </Animated.View>
      </Pressable>
    </Link>
  );
};

export default DateItems;
